// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntable[data-v-6fc2d633] {\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tmargin-bottom: 20px;\n}\n.bordered[data-v-6fc2d633] {\n\tborder: 1px solid #efefef;\n}\n.small[data-v-6fc2d633] {\n\tfont-size: 0.8em;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
